// extracted by mini-css-extract-plugin
export default {"panel":"CustomerContact_panel__BSXNh","row":"CustomerContact_row__V1Jn3","comment":"CustomerContact_comment__Cre77","bin":"CustomerContact_bin__5sKVk"};